import { apiCreate, apiDelete, apiGetOne, apiUpdate } from './ApiBaseActions';
export const INITIALIZE_PROFESSIONAL_SOLUTION = 'INITIALIZE_PROFESSIONAL_SOLUTION';
export const CHANGE_STEP_OF_PROFESSIONAL_SOLUTION = 'CHANGE_STEP_OF_PROFESSIONAL_SOLUTION';
export const API_GET_ONE_PROFESSIONAL_SOLUTION = 'API_GET_ONE_PROFESSIONAL_SOLUTION';
export const API_GET_ONE_PROFESSIONAL_SOLUTION_SUCCESS = 'API_GET_ONE_PROFESSIONAL_SOLUTION_SUCCESS';
export const API_CREATE_PROFESSIONAL_SOLUTION = 'API_CREATE_PROFESSIONAL_SOLUTION';
export const API_CREATE_PROFESSIONAL_SOLUTION_SUCCESS = 'API_CREATE_PROFESSIONAL_SOLUTION_SUCCESS';
export const API_UPDATE_PROFESSIONAL_SOLUTION = 'API_UPDATE_PROFESSIONAL_SOLUTION';
export const API_UPDATE_PROFESSIONAL_SOLUTION_SUCCESS = 'API_UPDATE_PROFESSIONAL_SOLUTION_SUCCESS';
export const API_DELETE_PROFESSIONAL_SOLUTION = 'API_DELETE_PROFESSIONAL_SOLUTION';
export const API_DELETE_PROFESSIONAL_SOLUTION_SUCCESS = 'API_DELETE_PROFESSIONAL_SOLUTION_SUCCESS';
export const initializeProfessionalSolution = () => ({
    type: INITIALIZE_PROFESSIONAL_SOLUTION,
});
export const changeStepOfProfessionalSolution = (step) => ({
    payload: { step },
    type: CHANGE_STEP_OF_PROFESSIONAL_SOLUTION,
});
export const apiGetOneProfessionalSolution = (id, meta) => apiGetOne(API_GET_ONE_PROFESSIONAL_SOLUTION, `/professional/solution/${id}`, meta);
export const apiCreateProfessionalSolution = (data, meta) => apiCreate(API_CREATE_PROFESSIONAL_SOLUTION, '/professional/solution', data, meta);
export const apiUpdateProfessionalSolution = (id, data, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_SOLUTION, `/professional/solution/${id}`, data, Object.assign({}, meta));
export const apiDeleteProfessionalSolution = (id, meta) => apiDelete(API_DELETE_PROFESSIONAL_SOLUTION, `/professional/solution/${id}`, meta);
